import { memo, useMemo } from "react";
import { func, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { browserName } from "react-device-detect";
import { Dialog } from "@components";

export const UnsupportedBrowserAlert = memo(({
  variant,
  onClose,
}) => {
  const {t} = useTranslation();
  
  const version = useMemo(() => (
    {
      Firefox: "121",
      Chrome: "119",
      EdgeChromium: "119",
      Safari: "17.4",
      Opera: "105",
    }[browserName]
  ), []);
  
  return (
    <Dialog
      open
      title={t("alerts.editor.unsupported_browser.title")}
      useCloseButton={Boolean(onClose)}
      onClose={onClose}
    >
      {t(
        `alerts.editor.unsupported_browser.${variant}.${version ? "known" : "unknown"}`,
        {
          version,
          name: browserName,
        }
      )}
    </Dialog>
  )
})

UnsupportedBrowserAlert.propTypes = {
  variant: oneOf(["proposal", "editor"]).isRequired,
  onClose: func,
}